import { trans } from "@mongez/localization";
import {
  formatLocalizedDate,
  formatRelativeTime,
  money,
} from "../../../core/shared/utils";
import { useOfferHeader } from "../hooks";

export function OfferHeader() {
  const {
    name,
    image,
    description,
    price,
    oldPrice,
    salePercentage,
    startsAt,
    endsAt,
    lessons,
  } = useOfferHeader();

  const isFree = price === 0;

  return (
    <div className="space-y-6">
      {/* Offer Image */}
      {image && (
        <div className="relative overflow-hidden rounded-xl">
          <img
            src={image.url}
            alt={name}
            className="max-h-100 m-auto object-cover"
          />
          {/* Sale Badge */}
          {salePercentage > 0 && (
            <div className="absolute left-4 top-4 rounded-full bg-red-500 px-3 py-1 text-sm font-bold text-white">
              {salePercentage}% {trans("offers.off")}
            </div>
          )}
        </div>
      )}

      {/* Offer Info */}
      <div className="space-y-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 sm:text-3xl lg:text-4xl">
            {name}
          </h1>
          {description && (
            <p className="mt-2 text-lg text-gray-600 dark:text-gray-300">
              {description}
            </p>
          )}
        </div>

        {/* Pricing */}
        <div className="flex items-center gap-4">
          <div
            className={`text-3xl font-bold ${isFree ? "text-green-600 dark:text-green-400" : "text-gray-900 dark:text-gray-100"}`}
          >
            {isFree ? trans("free") : money(price)}
          </div>
          {oldPrice > price && !isFree && (
            <>
              <div className="text-xl text-gray-500 line-through dark:text-gray-400">
                {money(oldPrice)}
              </div>
              <div className="rounded-full bg-green-100 px-3 py-1 text-sm font-semibold text-green-800 dark:bg-green-950/50 dark:text-green-300">
                {trans("offers.save")} {money(oldPrice - price)}
              </div>
            </>
          )}
        </div>

        {/* Offer Details: Hidden on mobile */}
        <div className="hidden grid-cols-1 gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-4">
          <div className="rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
            <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
              {trans("offers.lessonsIncluded")}
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              {lessons?.length || 0}
            </div>
          </div>

          {startsAt && (
            <div className="rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
              <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
                {trans("offers.startsAt")}
              </div>
              <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {formatLocalizedDate(startsAt)}
              </div>
            </div>
          )}

          {endsAt && (
            <div className="rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
              <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
                {trans("offers.endsAt")}
              </div>
              <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {formatLocalizedDate(endsAt)}
              </div>
              <div className="text-sm font-medium text-orange-600 dark:text-orange-400">
                {trans("offers.validUntil")}: {formatRelativeTime(endsAt)}
              </div>
            </div>
          )}

          <div className="rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
            <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
              {trans("offers.discount")}
            </div>
            <div className="text-2xl font-bold text-green-600 dark:text-green-400">
              {salePercentage}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
